import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState } from 'react'
import { Redirect, useHistory, useParams } from 'react-router-dom';

const CheckoutPageManager = () => {

    const history = useHistory();
    let { publicId } = useParams<{ publicId: string; }>();

    const urls = [
        'https://app-radi.vercel.app',
        'https://radialeman.com',
        "https://app-tau-six.vercel.app",
        "radi",
        "aleman",
        "app"
    ];

    const isValidUrl = useMemo(() => {
        return true;
        const referrer = document.referrer;

        for (let index = 0; index < urls.length; index++) {
            const url = urls[index];
            if (referrer.includes(url)) return true;
        }

        return false;
    }, []);

    useLayoutEffect(() => {
        if(typeof publicId === 'string' && publicId !== "" && isValidUrl){
            history.push({
                pathname: '/checkout',
                state: {
                    publicId: publicId
                }
            });
        }
        else history.push("/");
    }, [publicId, isValidUrl]);

    return null;
};

export default CheckoutPageManager;